<script setup lang="ts">
import { useAppStore } from '@/store/app'
import { ChevronLeftIcon } from '@gohighlevel/ghl-icons/24/outline'
import {
  UIButton,
  UISpace,
  UITextSmMedium,
  UIToolbar,
  UIToolbarGroup,
  UIInput,
  UIContentWrap,
} from '@gohighlevel/ghl-ui'
import { computed } from 'vue'
import DocumentActions from './ValidateDocument/DocumentActions.vue'
import { useBuilderStore } from '@/store/builder'
import { useI18n } from 'vue-i18n'

const appStore = useAppStore()
const builderStore = useBuilderStore()
const i18nLocale = useI18n()
const documentTitle = computed({
  get() {
    return appStore.document?.name
  },
  set(val: string) {
    appStore.document.name = val
  },
})

const emit = defineEmits<{
  (e: 'onBack'): void
}>()

function goBack() {
  emit('onBack')
}

function listenForTitleChanges(val: string) {
  appStore.updateDocumentName(val)
}
</script>

<template>
  <UIToolbar theme="light">
    <div class="w-1/12 flex flex-1 justify-start">
      <div class="inline-flex">
        <UIToolbarGroup border-right class="flex items-center">
          <UIButton id="btn-1" text @click="goBack">
            <ChevronLeftIcon class="w-5 h-5 text-gray-700" />
            <UITextSmMedium class="text-gray-700 font-medium">
              {{ $t('common.back') }}
            </UITextSmMedium>
          </UIButton>
        </UIToolbarGroup>
      </div>
    </div>
    <div class="w-6/12 md:w-3/12 flex flex-1 justify-center">
      <UIContentWrap
        :locale="(i18nLocale?.locale?.value as any) || 'en-US'"
        class="p-0"
        style="display: contents"
      >
        <UIToolbarGroup class="inline-flex justify-center items-center w-full">
          <UIInput
            id="document-title"
            :class="`w-full text-lg text-gray-700 max-w-md border px-3 rounded py-1 hover:bg-gray-100 cursor-pointer overflow-x-auto text-center whitespace-nowrap shadow-none ${
              !builderStore.isDocumentEditable
                ? 'pointer-events-none opacity-50'
                : ''
            }`"
            v-model="documentTitle"
            @update:model-value="val => listenForTitleChanges(val)"
          />
        </UIToolbarGroup>
      </UIContentWrap>
    </div>
    <div class="w-3/12 md:w-4/12 flex flex-1 justify-end">
      <UIToolbarGroup class="inline-flex justify-end items-center">
        <UISpace class="flex items-center space-x-3">
          <!-- <DocumentStateActions /> -->
          <DocumentActions />
        </UISpace>
      </UIToolbarGroup>
    </div>
  </UIToolbar>
</template>

<style lang="scss">
#document-title {
  border: 1px;
  input {
    height: 28px;
    line-height: 28px;
  }
}
</style>
